<template id="DateTimeInput">
  <date-picker
    input-class="form-control"
    popup-class="dropdown-menu"
    :type="inputType"
    :formatter="formatedDate"
    :range="rangeDate"
    v-model="dateValue"
    :placeholder="placeholder"
    :lang="lang"
    :disabled="disabled"
    :clearable="clearable"
    :editable="editable"
    :disabled-date="disabledDate"
    @change="changeDate"
    :showSecond="showSecond"
  />
</template>

<script>
import format from "date-fns/format/index.js";

export default {
  name: "DateTimeInput",
  props: {
    name: {
      type: String,
      default: "Date"
    },
    inputType: {
      type: String,
      default: "date"
    },
    showSecond:{
      type: Boolean,
      default: true
    },
    rangeDate: {
      type: Boolean,
      default: false
    },
    disabled: {
      type: Boolean,
      default: false
    },
    editable: {
      type: Boolean,
      default: true
    },
    clearable: {
      type: Boolean,
      default: true
    },
    setDate: {
      type: [Array, String],
      default: null
    },
    formatType: { type: String, default: null },
    maxDate: {
      type: String,
      default: null
    },
    minDate: {
      type: String,
      default: null
    }
  },
  data: function() {
    return {
      id: null,
      icon: "fa-calendar",
      dateValue: null,
      lang: {
        formatLocale: {
          firstDayOfWeek: 1 // 週一為第一天
        }
      },
      formatedDate: {
        stringify: date => {
          return date ? format(new Date(date), this.dateFormat) : "";
        },
        parse: value => {
          return value
            ? format(new Date(value), this.dateFormat).toDate()
            : null;
        }
      }
    };
  },
  computed: {
    placeholder() {
      return "Select a date";
    },
    dateFormat() {
      if (this.formatType != null) {
        return this.formatType;
      }
      if (this.inputType === "datetime") {
        return "yyyy/MM/dd HH:mm:ss";
      }

      if (this.inputType === "month") {
        return "yyyy/MM";
      }

      return "yyyy/MM/dd";
    },
    startDate() {
      return this.setDate.split(" ~ ")[0];
    },
    endDate() {
      return this.setDate.split(" ~ ")[1];
    }
  },
  watch: {
    value(val) {
      this.dateValue = val;
    },
    inputType(val) {
      if (val == "time") {
        this.icon = "fa-clock-o";
      } else {
        this.icon = "fa-calendar";
      }
    },
    setDate(to) {
      if (to == null || to.lengh == 0) {
        this.dateValue = "";
        return;
      }
      if (this.rangeDate) {
        if (this.endDate && this.endDate.length == 0) {//防呆
          this.dateValue = [new Date(this.startDate), new Date("9999/12/31")];
          return;
        }
        this.dateValue = [new Date(this.startDate), new Date(this.endDate)];
        return;
      }
      this.dateValue = new Date(to);
    }
  },
  methods: {
    disabledDate(date) {
      if (this.maxDate != null && this.minDate == null) {
        return new Date(this.maxDate) < date;
      } else if (this.minDate != null && this.maxDate == null) {
        return new Date(this.minDate) > date;
      } else if (this.minDate != null && this.maxDate != null) {
        return new Date(this.minDate) > date || new Date(this.maxDate) < date;
      }
      return null;
    },
    changeDate(value) {
      this.dateValue = value;
      this.$emit("changeDate", { name: this.name, value: this.dateValue });
    },
    clearDate() {
      this.dateValue = null;
      this.$emit("changeDate", { name: this.name, value: this.dateValue });
    },
    initial() {
      this.dateValue = "";
      if (this.setDate == null || (this.setDate && this.setDate.length == 0)) {//防呆
        return;
      }
      if (this.rangeDate) {
        if (this.endDate && this.endDate.length == 0) {//防呆
          this.dateValue = [new Date(this.startDate), new Date("9999/12/31")];
          return;
        }
        this.dateValue = [new Date(this.startDate), new Date(this.endDate)];
        return;
      }
      this.dateValue = new Date(this.setDate);
    }
  },
  mounted() {
    this.initial();
  }
};
</script>
<style>
.dropdown-menu.mx-datepicker-popup {
  display: block !important;
  z-index: 2001 !important;
}
.mx-datepicker-main {
  font: 14px/1.5 "Helvetica Neue", Helvetica, Arial, "Microsoft Yahei",
    sans-serif;
  color: #73879c !important;
  background-color: #fff !important;
  border: 1px solid #e8e8e8 !important;
}
.mx-table-date .today {
  color: #96694c !important;
}
.mx-calendar-content .cell.active {
  background-color: #96694c !important;
  color: #fff !important;
}
</style>
